/**
 * 周边设施
 * 
 * @Author: Focci
 * @Date: 2024-07-02 16:15:19
 * @Last Modified by: Focci
 * @Last Modified time: 2024-07-02 16:15:19
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import { Skeleton } from '@comp/material'
import { Waypoint } from 'react-waypoint'
import { useCallback, useState } from 'react'
import PropertyItemScoff from '../PropertyItemScoff'

export function SurroundingFacilitiesSkeleton(props) {
  return (
    <div {...props}>
      <Skeleton variant="text" style={{ fontSize: '1.5rem', width: '30%' }} />
      <Skeleton variant="text" style={{ fontSize: '1rem', width: '50%' }} />
      <Skeleton variant="text" style={{ width: '90%' }} />
      <Skeleton variant="text" style={{ width: '70%' }} />
      <Skeleton variant="text" style={{ fontSize: '1rem', width: '50%', marginTop: '1.5rem' }} />
      <Skeleton variant="text" style={{ width: '90%' }} />
      <Skeleton variant="text" style={{ width: '70%' }} />
    </div>
  )
}

export default function SurroundingFacilities({ data, house }) {
  const { Wedget, getWedget, ready } = useLazyComponent()

  const [enter, setEnter] = useState(false)
  
  const handleEnter = useCallback(async () => {
    setEnter(true)
    getWedget(() => import('./SurroundingFacilitiesBody'))
  }, [getWedget])

  return (
    <Waypoint onEnter={handleEnter}>
      <PropertyItemScoff
        title={data.title}
        moduleName={data.title}
        id="module-surrounding-facilities"
      >
        {
          !enter
            ? (<div className="min-h-[9rem] md:min-h-[18.5rem]" />)
            : ready
              ? <Wedget data={data} house={house} />
              : (
                <div className="min-h-[9rem] md:min-h-[18.5rem] grid grid-cols-1 md:grid-cols-2 gap-6">
                  <SurroundingFacilitiesSkeleton />  
                  <SurroundingFacilitiesSkeleton className="hidden md:block" />
                </div>
              )
        }
      </PropertyItemScoff>
    </Waypoint>
  )
}

SurroundingFacilities.propTypes = {
  data: PropTypes.object,
  house: PropTypes.object,
}
